module.exports = __webpack_public_path__ + "static/media/equity_derivatives_transparent.7c1ade50.svg";